import React from 'react';
import classNames from 'classnames';

import styles from './index.module.css';

interface BenefitItemProps {
  text: string;
  icon?: 'check' | 'tag';
}

export interface BenefitSection {
  title?: string;
  items: BenefitItemProps[];
}

interface BenefitListProps {
  sections: BenefitSection[];
}

const BenefitList: React.FC<BenefitListProps> = ({ sections }) => {
  return (
    <div className={styles.benefitList}>
      {sections.map((section, sIdx) => (
        <div key={sIdx} className={styles.section}>
          {section.title && <p className={styles.sectionTitle}>{section.title}</p>}
          <div className={styles.items}>
            {section.items.map((item, iIdx) => (
              <div key={iIdx} className={styles.item}>
                {item.icon !== 'tag' ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className={styles.icon}
                  >
                    <path
                      d="M14.0116 2.33301C10.161 4.78222 7.4283 8.28337 6.16797 9.83301L2.83464 7.16634L1.66797 8.05877L6.98164 13.6663C7.89364 11.2368 10.7943 6.48944 14.3346 3.11439L14.0116 2.33301Z"
                      fill="#F0F1F5"
                    />
                  </svg>
                ) : (
                  <span className={styles.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="4"
                      height="4"
                      viewBox="0 0 4 4"
                      fill="none"
                    >
                      <circle cx="2" cy="2" r="2" fill="#D5D6D9" />
                    </svg>
                  </span>
                )}
                <span
                  className={classNames(styles.text, {
                    [styles.subText]: item.icon === 'tag',
                  })}
                >
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(BenefitList);
